import { useFormFieldState } from 'common';

import {
  OrganizationAutocomplete,
  type OrganizationAutocompleteProps,
} from '../Autocomplete/Organization';

interface OrganizationControlProps extends Omit<
  OrganizationAutocompleteProps,
  'onChange' | 'value'
> {
  name: string;
  excludedIds?: string[];
  onChange?: (value: string | string[] | undefined) => void;
}

export function OrganizationControl(props: OrganizationControlProps) {
  const {
    name,
    isMultiple,
    excludedIds,
    onChange,
    label,
    'aria-label': ariaLabel,
    ...autocompleteProps
  } = props;

  const {
    value,
    setValue,
    errorMessage,
    fieldProps: { onBlur },
  } = useFormFieldState<string[] | string | undefined>({
    name,
  });

  if (isMultiple) {
    const arrayValue = Array.isArray(value) ? value : [];
    return (
      <OrganizationAutocomplete
        {...autocompleteProps}
        label={label}
        aria-label={ariaLabel ?? 'Organization'}
        value={arrayValue}
        isMultiple={true}
        onChange={(value: string[] | undefined) => {
          void setValue(value ?? []);
          onChange?.(value ?? []);
        }}
        onBlur={onBlur}
        errorMessage={errorMessage}
        excludedIds={excludedIds}
      />
    );
  }

  return (
    <OrganizationAutocomplete
      {...autocompleteProps}
      label={label}
      aria-label={ariaLabel ?? 'Organization'}
      name={name}
      value={typeof value === 'string' ? value : ''}
      isMultiple={false}
      onChange={(value?: string) => {
        void setValue(value ?? '');
        onChange?.(value ?? '');
      }}
      onBlur={onBlur}
      errorMessage={errorMessage}
      excludedIds={excludedIds}
    />
  );
}
